import { DeleteProductFromMyWishlistInput } from '@spa/generated/graphql/graphql';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiDeleteProductFromMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly input: DeleteProductFromMyWishlistInput;
  readonly parentActionId: number;
}

export const apiDeleteProductFromMyWishlistRequestedType =
  'api/wishlist/deleteProductFromMyWishlist--requested';
export const apiDeleteProductFromMyWishlistRequested = createAction<
  ApiDeleteProductFromMyWishlistRequestedPayload,
  typeof apiDeleteProductFromMyWishlistRequestedType
>(apiDeleteProductFromMyWishlistRequestedType);
export type ApiDeleteProductFromMyWishlistRequestedAction = ReturnType<
  typeof apiDeleteProductFromMyWishlistRequested
>;

export interface ApiDeleteProductFromMyWishlistSucceededPayload {
  readonly input: DeleteProductFromMyWishlistInput;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiDeleteProductFromMyWishlistSucceededType =
  'api/wishlist/deleteProductFromMyWishlist--succeeded';
export const apiDeleteProductFromMyWishlistSucceeded = createAction<
  ApiDeleteProductFromMyWishlistSucceededPayload,
  typeof apiDeleteProductFromMyWishlistSucceededType
>(apiDeleteProductFromMyWishlistSucceededType);
export type ApiDeleteProductFromMyWishlistSucceededAction = ReturnType<
  typeof apiDeleteProductFromMyWishlistSucceeded
>;

export interface ApiDeleteProductFromMyWishlistFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly error: WishlistError;
}

export const apiDeleteProductFromMyWishlistFailedType =
  'api/wishlist/deleteProductFromMyWishlist--failed';
export const apiDeleteProductFromMyWishlistFailed = createAction<
  ApiDeleteProductFromMyWishlistFailedPayload,
  typeof apiDeleteProductFromMyWishlistFailedType
>(apiDeleteProductFromMyWishlistFailedType);
export type ApiDeleteProductFromMyWishlistFailedAction = ReturnType<
  typeof apiDeleteProductFromMyWishlistFailed
>;
